import Mock from "../mock";

const database = {
  information: {
    name: "Carrick Taehong Park",
    aboutContent:
      "I’m a hands-on web developer specializing in building interactive, high-performance websites. I focus on clean, maintainable code and optimizing user experience to meet business goals.",
    //age: 34,
    phone: "0430 542 144",
    // nationality: 'American',
    language: "English, Korean",
    email: "univerpark@naver.com",
    address: "Castle Hill, NSW 2154",
    // freelanceStatus: 'Available',
    socialLinks: {
      facebook: "https://facebook.com",
      twitter: "https://twitter.com",
      pinterest: "",
      behance: "",
      linkedin: "",
      dribbble: "",
      github: "https://github.com",
    },
    // brandImage: "/images/brand-image.jpg",
    // aboutImage: "/images/about-image.jpg",
    brandImage: "/images/p1.jpg",
    aboutImage: "/images/p1.jpg",
    aboutImageLg: "/images/about-image-lg.jpg",
    cvfile: "/files/Resume CarrickPark.pdf",
  },
  services: [
    // {
    //   title: "Web Design",
    //   icon: "color-pallet",
    //   details:
    //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem tenetur ratione quod.",
    // },
    {
      title: "Front-End Development",
      icon: "code",
      details:
        "I specialize in developing web applications using JavaScript and ReactJS. Additionally, I have extensive experience working with WordPress and PHP. I am proficient in SCSS and Bootstrap, enabling me to create responsive and visually appealing user interfaces.",
    },
    {
      title: "Back-End Development",
      icon: "mouse",
      details:
        "I have an experience in designing and implementing robust, scalable, and efficient server-side applications. My expertise spans across Java and Node.js for backend development, along with a strong proficiency in Linux for server management and deployment.",
    },
    {
      title: "API Development",
      icon: "code",
      details:
        "Skilled in designing and implementing RESTful APIs, ensuring seamless communication between client and server applications.",
    },
    {
      title: "DevOps",
      icon: "mouse",
      details:
        "Familiar with CI/CD pipelines and containerization technologies like ASW and Git, facilitating streamlined development and deployment processes.",
    },
  ],
  references: [
    {
      name: "Silvana Habib",
      title: "7th Avenue Business owner",
      contact: "0415 180 066",
      email: "silvanahabib22@icloud.com",
    },
    {
      name: "Ji eun Lee",
      title: "Elshuo Business owner",
      contact: "0413 685 948",
      email: "admin@elshuo.com.au",
    },
  ],
  reviews: [
    {
      id: 1,
      content:
        "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita impedit nobis tempore quaerat quibusdam, aliquid maxime tempora.",
      author: {
        name: "Burdette Turner",
        designation: "Web Developer, Abc Company",
      },
    },
    {
      id: 2,
      content:
        "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita impedit nobis tempore quaerat quibusdam.",
      author: {
        name: "Susan Yost",
        designation: "Client",
      },
    },
    {
      id: 3,
      content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
      author: {
        name: "Irving Feeney",
        designation: "Fiverr Client",
      },
    },
  ],
  skills: [
    {
      title: "HTML/CSS",
      value: 100,
    },
    {
      title: "JavaScript",
      value: 100,
    },
    {
      title: "jQuery",
      value: 85,
    },
    {
      title: "Wordpress",
      value: 100,
    },
    {
      title: "Shopify",
      value: 100,
    },
    {
      title: "ReactJS",
      value: 90,
    },
    {
      title: "NodeJS",
      value: 75,
    },
    {
      title: "PHP",
      value: 95,
    },
    {
      title: "C#",
      value: 90,
    },
    {
      title: "Java",
      value: 90,
    },
    {
      title: "Python",
      value: 85,
    },
    {
      title: "Linux",
      value: 80,
    },
  ],
  portfolios: [
    {
      id: 1,
      title: "Scripture Union",
      subtitle:
        "- JavaScript, Bootstrap, Wordpress/PHP, Salesforce Connection, Setting data sync between Wordpress and Salesforce, Google Map API/Customise marker, ",
      imageUrl: "/images/su1.png",
      largeImageUrl: ["/images/su1.png", "/images/su2.png", "/images/su3.png"],
      url: "https://sunsw.org.au",
    },
    {
      id: 2,
      title: "NTE",
      subtitle: "- JavaScript, Bootstrap, Wordpress/PHP, From 2021 every year update the site in different design",
      imageUrl: "/images/nte1.png",
      largeImageUrl: ["/images/nte1.png", "/images/nte2.png", "/images/nte3.png"],
      url: "https://nte.org.au/",
    },
    {
      id: 3,
      title: "Meet Jesus",
      subtitle: "- JavaScript, Bootstrap, Wordpress/PHP, Login and out function using local storage",
      imageUrl: "/images/meetJesus1.png",
      largeImageUrl: ["/images/meetJesus1.png", "/images/meetJesus2.png", "/images/meetJesus3.png"],
      url: "https://meetjesus.au/",
    },
    {
      id: 4,
      title: "Hey Lemonade",
      subtitle: "- JavaScript, Bootstrap, Wordpress/PHP, Linked to mobile application",
      imageUrl: "/images/hl1.png",
      largeImageUrl: ["/images/hl1.png", "/images/hl2.png", "/images/hl3.png"],
      url: "https://heylemonade.com.au/",
    },
    {
      id: 5,
      title: "IJM Singapore",
      subtitle: "- JavaScript, Bootstrap, Wordpress/PHP, NGO Website",
      imageUrl: "/images/ijmsg1.png",
      largeImageUrl: ["/images/ijmsg1.png", "/images/ijmsg2.png", "/images/ijmsg3.png"],
      url: "https://ijmsg.org/",
    },
    {
      id: 6,
      title: "Finding Ruby",
      subtitle: "- JavaScript, Bootstrap, Wordpress/PHP, Podcast",
      imageUrl: "/images/fr1.png",
      largeImageUrl: ["/images/fr1.png", "/images/fr2.png", "/images/fr3.png"],
      url: "https://fightofmy.life/",
    },
    {
      id: 7,
      title: "Artmar",
      subtitle: "- JavaScript, Bootstrap, Wordpress/PHP, Tile company",
      imageUrl: "/images/artmar1.png",
      largeImageUrl: ["/images/artmar1.png", "/images/artmar2.png", "/images/artmar2.png"],
      url: "https://artmar.com.au/",
    },
    {
      id: 8,
      title: "MAF Father's Day Shopify",
      subtitle: "- JavaScript, Liquid, Shopify, Customise theme",
      imageUrl: "/images/ms1.png",
      largeImageUrl: ["/images/ms1.png", "/images/ms2.png", "/images/ms3.png"],
      url: "https://gifts.maf.org.au/pages/fathersday",
    },
    {
      id: 9,
      title: "Cadence",
      subtitle: "- Wordpress, PHP, Javascript, Containing portfolios and team member",
      imageUrl: "/images/c1.png",
      largeImageUrl: ["/images/c1.png"],
      url: "https://cadencemedia.com.au/",
    },
    {
      id: 10,
      title: "Elshuo Cat sitter",
      subtitle: "- JavaScript, Bootstrap, Jquery, Hosting on AWS S3, Template used, Commercial website to sell kittens",
      imageUrl: "/images/e1.jpg",
      largeImageUrl: ["/images/e1.jpg", "/images/e2.jpg", "/images/e3.jpg"],
      url: "https://elshuo.com.au",
    },
    {
      id: 11,
      title: "Belvedere Dural",
      subtitle: "- Wordpress, PHP, Javascript, Property Website",
      imageUrl: "/images/b1.png",
      largeImageUrl: ["/images/b1.png"],
      url: "https://belvederedural.com.au/",
    },
    {
      id: 12,
      title: "Counsel Culture",
      subtitle: "- Wordpress, PHP, Podcast website, Upload blog and audio everyweek",
      imageUrl: "/images/cc1.png",
      largeImageUrl: ["/images/cc1.png"],
      url: "https://counselculture.org.au/",
    },
    {
      id: 13,
      title: "IJM HONG KONG",
      subtitle: "- Wordpress, PHP, Javascript, NGO website, Built it based on other brench's website template",
      imageUrl: "/images/ijm1.png",
      largeImageUrl: ["/images/ijm1.png"],
      url: "https://ijmhk.org/",
    },
    {
      id: 14,
      title: "Saigon Fabrtics",
      subtitle: "- JavaScript, Bootstrap, Wordpress/PHP, Wish List using local storage",
      imageUrl: "/images/saigon1.png",
      largeImageUrl: ["/images/saigon1.png", "/images/saigon2.png", "/images/saigon3.png"],
      url: "https://www.saigonfabrics.com.au/",
    },
    {
      id: 15,
      title: "Race Maf",
      subtitle:
        "- Raisely platform, ReactJS, ReactJS(Axios), Using RESTapi from raisely, Campaign for donation, Use input data and this app bring data with RESTapi and display on screen",
      imageUrl: "/images/race1.png",
      largeImageUrl: ["/images/race1.png"],
      // url: "https://cadencemedia.net.au/racemaf/",
    },
    {
      id: 16,
      title: "Quay Park Hospital(Evolution Healthcare)",
      subtitle:
        "- Wordpress, PHP, Javascript, Duplicated it from other site in same foundation and organised(Changing name, uploading images)",
      imageUrl: "/images/q1.png",
      largeImageUrl: ["/images/q1.png"],
      url: "https://quayparksurgical.co.nz/",
    },
    {
      id: 17,
      title: "7th Avenue Sales",
      subtitle:
        "- ReactJS, NodeJS, Axios-API, Hosting on AWS EC2, Company internal page. Request API from POS company. The page shows selected infomation(Sales, Amount, Time). Deployed by AWS EC2(Linux). Partially developed in Linux environment",
      imageUrl: "/images/l1.jpg",
      largeImageUrl: ["/images/l1.jpg"],
      // url: "http://everlane7.com.au",
    },
    {
      id: 18,
      title: "7th Avenue",
      subtitle: "- JavaScript, Bootstrap, Commercial Website for Fashion retail shops",
      imageUrl: "/images/s1.jpg",
      largeImageUrl: ["/images/s1.jpg", "/images/s2.jpg", "/images/s3.jpg"],
      // url: "http://gietpa.dothome.co.kr",
    },
  ],
  experience: {
    workingExperience: [
      {
        id: 1,
        year: "Mar.2021 - Present",
        position: "Web Developer",
        company: "Cadence",
        details: [
          "- Develop and maintain client web applications, delivering custom solutions using Shopify, WordPress, PHP, JavaScript, jQuery, Bootstrap, and APIs including Salesforce.",
          "- Write clean, modular code and troubleshoot issues to ensure reliable, scalable performance.",
          "- Collaborate using GitHub for version control, code reviews, and efficient team workflows.",
          "- Contribute to internal automation projects that streamline workflows and reduce manual effort.",
        ],
      },
      // {
      //   id: 2,
      //   year: "Nov.2020 - Dec.2021",
      //   position: "Frontend/Web Developer",
      //   company: "Elshuo Cattery",
      //   // details: [
      //   //   { id: 1, detail: "- Develop Cattery Website" },
      //   //   { id: 2, detail: "- Update and upload data following season" },
      //   //   { id: 3, detail: "- Use JavaScript, Jquery and Bootstrap" },
      //   // ],
      // },
      {
        id: 3,
        year: "Feb.2018 - Feb.2021",
        position: "Web Developer / IT Administrator",
        company: "7th Avenue Fashion",
        details: [
          "- Managed web application development projects from initial design through completion, optimizing all cross-browser and multi-platform compatibility.",
          "- Developed websites from frontend to backend using JavaScript, jQuery, Bootstrap, ReactJS, and NodeJS.",
          "- Developed a web application to display sales using an API provided by a POS company.",
          "- Worked in Windows and Linux environments.",
        ],
      },
      {
        id: 4,
        year: "Sep.2015 - Feb.2018",
        position: "Web Developer / IT Administrator",
        company: "MInk Fashion Pty Ltd",
        details: [
          "- Developed websites using JavaScript, jQuery, and HTML.",
          "- Analyzed raw data from databases regarding sales and branch information.",
          "- Performed database programming with SQL to handle data from branches.",
          "- Updated websites and uploaded data according to seasonal and sales plans.",
          "- Worked in Windows and Linux environments.",
        ],
      },
      {
        id: 5,
        year: "Jul.2005 - Oct.2007",
        position: "Munitions Administrative Clerk",
        company: "Korean Air Force",
        details: [
          "- Managed munitions in military troop. ",
          "- Stock management in military troop. ",
          "- Military supply work.",
        ],
      },
    ],
    educationExperience: [
      {
        id: 1,
        year: "2011 - 2014",
        graduation: "Bachelor of Science in Information Technology",
        university: "University of Technology Sydney, Australia",
        details: ["- Enterprise system development", "- Sofrwate development"],
      },
      {
        id: 2,
        year: "Jun.2014 - Jul.2014",
        graduation: "Window Server, Linux Server Certificate",
        university: "Soldesk IT training centre, South Korea",
        details: ["- Linux(RHEL) ", "- Window server 2003, 2008, 2012"],
      },
      {
        id: 3,
        year: "2010",
        graduation: "Diploma of Information Technology",
        university: "Insearch, Australia",
        details: ["- Sofrwate development ", "- Networking"],
      },
    ],
  },
  blogs: [
    {
      id: 1,
      title: "Markdown & Html supported blog.",
      featuredImage: "/images/blog-image-1.jpg",
      filesource: "../../blog/markdown-html-supported-blog.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 2,
      title: "Installing NodeJS on your device.",
      featuredImage: "/images/blog-image-2.jpg",
      filesource: "../../blog/installing-nodejs-on-your-device.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 3,
      title: "UI/UX design starter with Adobe XD.",
      featuredImage: "/images/blog-image-3.jpg",
      filesource: "../../blog/uiux-design-starter-with-adobe-xd.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 4,
      title: "Boost your post for increasing sales.",
      featuredImage: "/images/blog-image-4.jpg",
      filesource: "../../blog/boost-your-post-for-increasing-sales.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 5,
      title: "Difference between GatsbyJS & NextJS.",
      featuredImage: "/images/blog-image-5.jpg",
      filesource: "../../blog/difference-between-gatsbyjs-and-nextjs.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 6,
      title: "How to choose javascript framework for project.",
      featuredImage: "/images/blog-image-6.jpg",
      filesource: "../../blog/how-to-choose-javascript-framework-for-project.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 7,
      title: "Web automation with python language.",
      featuredImage: "/images/blog-image-7.jpg",
      filesource: "../../blog/web-automation-with-python-language.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 8,
      title: "Time to use latest technology for creating a website.",
      featuredImage: "/images/blog-image-8.jpg",
      filesource: "../../blog/time-to-use-latest-technology-for-creating-a-website.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 9,
      title: "Think out of the box.",
      featuredImage: "/images/blog-image-9.jpg",
      filesource: "../../blog/think-out-of-the-box.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 10,
      title: "Trending designs in 2020.",
      featuredImage: "/images/blog-image-1.jpg",
      filesource: "../../blog/trending-designs-in-2020.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 11,
      title: "How to get 10k instagram followers?",
      featuredImage: "/images/blog-image-2.jpg",
      filesource: "../../blog/how-to-get-10k-instagram-followers.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 12,
      title: "What NodeJS can do?",
      featuredImage: "/images/blog-image-3.jpg",
      filesource: "../../blog/what-nodejs-can-do.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 13,
      title: "Futures of javascript.",
      featuredImage: "/images/blog-image-4.jpg",
      filesource: "../../blog/future-of-javascript.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 14,
      title: "Popular javascript library in 2020.",
      featuredImage: "/images/blog-image-5.jpg",
      filesource: "../../blog/popular-javascript-library-in-2020.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 15,
      title: "Promrammers must read books.",
      featuredImage: "/images/blog-image-6.jpg",
      filesource: "../../blog/programmers-must-read-books.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
  ],
  contactInfo: {
    phoneNumbers: ["+61 0430 542 144"],
    emailAddress: ["univerpark@naver.com"],
    address: "Castle Hill, NSW 2154 Australia",
  },
};

Mock.onGet("/api/information").reply((config) => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply((config) => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/references").reply((config) => {
  const response = database.references;
  return [200, response];
});

Mock.onGet("/api/reviews").reply((config) => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply((config) => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/portfolios").reply((config) => {
  const response = database.portfolios;
  return [200, response];
});

Mock.onGet("/api/experience").reply((config) => {
  const response = database.experience;
  return [200, response];
});

Mock.onGet("/api/blog").reply((config) => {
  const response = database.blogs;
  return [200, response];
});

Mock.onGet("/api/contactinfo").reply((config) => {
  const response = database.contactInfo;
  return [200, response];
});
